<template>
  <div class="transaction-item-info">
    <div class="transaction-item-info__item">
      <div class="transaction-item-info__group">
        <div class="transaction-item-info__title">
          {{ $t('operation-information.service-item.service-code') }}
        </div>
        <div class="transaction-item-info__value"></div>
      </div>
      <div class="transaction-item-info__group">
        <div class="transaction-item-info__title">
          {{ $t('operation-information.service-item.sum') }}
        </div>
        <div class="transaction-item-info__value"></div>
      </div>
    </div>
  </div>
</template>

<script>
import { Transaction } from '@js-app/entities/transaction/Transaction'

export default {
  name: 'TransactionItemServiceItemInfo',
  props: {
    transaction: {
      type: Transaction,
    },
  },
}
</script>
